import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import moment from 'moment';
import FMPHeadline from '../../components/ui/FMPHeadline';
import Button from '@material-ui/core/Button';
import Search from '@material-ui/icons/Search';

import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';

import { valueToDisplay } from '../../libs/products';
import { getLegs as getDeliveryLegs } from '../../libs/deliveryLegs';

import { invoiceStatusClassNames } from '../accounting/general';
import invoiceIcon from '../../images/invoicePdf.svg';
import quickbooksLogo from '../../images/quickbooksLogo.svg';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormComponent from '../../components/FormComponent';
import { post } from '../../modules/utility';
import OpenLink from '@material-ui/icons/OpenInNew';
import EnhancedTable from '../../components/table/EnhancedTable';
import Popover from '@material-ui/core/Popover';

import { green } from '@material-ui/core/colors';
import orange from '@material-ui/core/colors/orange';
import NoteIcon from '@material-ui/icons/Note';
import { getSharedStyles } from '../../themes';
import AuthUserContainer from '../../containers/AuthUser';
import UsersContainer from '../../containers/Users';
import FMPUserMultiSelect from '../../components/pureForm/FMPUserMultiSelect';
import DownloadIcon from '@material-ui/icons/CloudDownload';
const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => {
	return {
		...invoiceStatusClassNames,
		...getSharedStyles(theme),
		bigButton: {
			borderRadius: '100px',
			padding: '18px 34px',
			fontSize: 16,
		},
		smallButton: {
			borderRadius: '100px',
			fontWeight: 200,
		},
		pickPlease: {
			background: '#F7F7F7',
			border: '1px solid #DDDDDD',
			padding: 20,
			color: '#666',
		},
		divider: {
			borderBottom: '1px dashed #dddddd',
			marginBottom: 25,
			marginTop: 25,
		},
		stats: {
			padding: '20px 10px 20px 10px',
			borderBottom: '1px solid #ddd',
			marginBottom: 10,
		},
		statGroup: {
			padding: '5px 5px 10px 5px',
			borderBottom: '1px solid #eee',
			marginBottom: 10,
		},
		available: {
			fontWeight: 900,
		},
		invoiceDocument: {
			position: 'absolute',
		},
		invoiceDocumentContainer: {
			position: 'relative',
			display: 'flex',
			alignItems: 'center',
		},
		invoiceIcon: {
			display: 'inline-block',
			width: 40,
			height: 48,
			backgroundImage: `url('${invoiceIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		quickbooksIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${quickbooksLogo}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		table: {
			width: '100%',
			tableLayout: 'auto',
		},
		row: {
			cursor: 'pointer',
		},
		button: {
			verticalAlign: 'middle',
			padding: '8px 10px',
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 5,
			display: 'flex',
			alignItems: 'center',
			fontSize: 16,
			color: '#666',
		},
		dateRange: {
			marginRight: 10,
		},
		icon: {
			marginRight: 5,
		},
		linkedItem: {
			fontSize: 14,
			textDecoration: 'none',
			display: 'flex',
			alignItems: 'center',
		},
		openLink: {
			paddingLeft: 4,
			width: 14,
			height: 14,
		},
		diffError: {
			fontWeight: 900,
			color: '#FF500F',
		},
		contractSub: {
			paddingLeft: 10,
			fontSize: 14,
			color: '#666',
		},
		todo: {
			border: `1px solid #bbb`,
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		addButton: {
			verticalAlign: 'middle',
			textDecoration: 'none',
			marginBottom: 10,
			borderRadius: 100,
		},
		fuelGroup: {
			marginBottom: 7,
		},
		savedSearchHelp: {
			padding: 10,
			color: '#444',
			backgroundColor: '#f7f7f7',
			border: '1px solid #eee',
			marginTop: 5,
			fontWeight: 200,
			marginBottom: 10,
		},
		saveNewSearchSection: {
			//borderTop : '1px solid #d7d7d7',
			marginTop: 20,
			paddingTop: 10,
		},
		noSavedSearches: {
			color: '#666',
			padding: 5,
			fontStyle: 'italic',
		},
		savedSearchContainer: {
			marginTop: 10,
			paddingTop: 10,
			borderBottom: '1px solid #d7d7d7',
			marginBottom: 10,
			paddingBottom: 5,
			display: 'flex',
			justifyContent: 'space-between',
		},
		addedOn: {
			fontSize: '85%',
			fontWeight: 200,
			color: '#666',
			paddingTop: 3,
		},
		snackbarSuccess: {
			backgroundColor: green[600],
		},
		snackbarIcon: {
			opacity: 0.9,
			marginRight: theme.spacing(1),
			fontSize: 20,
		},
		snackbarMessage: {
			display: 'flex',
			alignItems: 'center',
		},
		cancelled: {
			color: orange[500],
			fontWeight: 900,
		},
		popOverPaper: {
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
		},
		commentsContainer: {
			padding: 7,
			display: 'inline-block',
			fontSize: '95%',
		},
		commentDateTime: {
			fontSize: '80%',
			color: '#666',
		},
		popover: {
			pointerEvents: 'none',
		},
	};
};

class DeliveryActivityLogSearch extends FormComponent {
	constructor(props) {
		super(props);

		this.state = {
			formFieldError: {},
			deliveryType: 'all',
			dateRange: 'last7Days',
			afterDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			beforeDate: moment().format('YYYY-MM-DD'),
			isSearching: false,
			forUserIds: [],
			commentPopoverAnchor: undefined,
			popoverComment: '',
			deliveryLogRows: undefined,
		};
	}

	componentDidMount() {
		const { isExternalLogistics, users, searchUsers } = this.props;

		if (!isExternalLogistics) {
			if (_.isEmpty(users)) {
				searchUsers();
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.dateRange !== prevState.dateRange) {
			if (this.state.dateRange === 'today') {
				this.setState({
					afterDate: moment().format('YYYY-MM-DD'),
					beforeDate: moment().format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'last7Days') {
				this.setState({
					afterDate: moment().subtract(7, 'days').format('YYYY-MM-DD'),
					beforeDate: moment().format('YYYY-MM-DD'),
				});
			} else if (this.state.dateRange === 'last30Days') {
				this.setState({
					afterDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
					beforeDate: moment().format('YYYY-MM-DD'),
				});
			}
		}
	}

	getApiParams = () => {
		const { accessToken } = this.props;

		const { forUserIds, afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate).startOf('day').utc();
		const beforeMoment = moment(beforeDate).endOf('day').utc();

		return {
			accessToken,
			forUserIds,
			afterDateTime: afterMoment.format('YYYY-MM-DD hh:mm:ss'),
			beforeDateTime: beforeMoment.format('YYYY-MM-DD hh:mm:ss'),
		};
	};

	submitSearch = () => {
		const { showErrors } = this.props;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		this.setState({
			isSearching: true,
		});

		const params = this.getApiParams();
		post({
			method: 'stationDelivery.log.advancedSearch',
			params,
			callback: (err, apiSearchResult) => {
				this.setState({ isSearching: false });
				if (err) {
					return showErrors(_.isArray(err) ? err : [err]);
				}
				this.formatSearchResults(apiSearchResult);
			},
		});
	};

	formatSearchResults = (apiSearchResult) => {
		const { classes } = this.props;
		const { collections } = apiSearchResult;

		const {
			stationDeliveryLogCollection,
			stationDeliveryCollection,
			stationCollection,
			carrierCollection,
			supplierCollection,
			terminalCollection,
			userCollection,
		} = collections;

		const stationLookup = _.keyBy(stationCollection, 'stationId');
		const carrierLookup = _.keyBy(carrierCollection, 'carrierId');
		const supplierLookup = _.keyBy(supplierCollection, 'supplierId');
		const terminalLookup = _.keyBy(terminalCollection, 'terminalId');
		const userLookup = _.keyBy(userCollection, 'userId');
		const stationDeliveryLookup = _.keyBy(stationDeliveryCollection, 'stationDeliveryId');

		let deliveryLogRows = [];
		stationDeliveryLogCollection.forEach((stationDeliveryLog) => {
			const row = this.formatStationDeliveryLog({
				stationDeliveryLog,
				stationDeliveryLookup,
				stationLookup,
				terminalLookup,
				carrierLookup,
				supplierLookup,
				userLookup,
				classes,
			});
			deliveryLogRows.push(row);
		});

		/*
		const bulkCustomerLookup = _.keyBy(bulkCustomerCollection, 'bulkCustomerId');
		bulkDeliveries.forEach(bulkDelivery => {
			const row = this.formatBulkDelivery({
				bulkDelivery,
				bulkCustomerLookup,
				terminalLookup,
				carrierLookup,
				supplierLookup,
				bulkInvoiceLookup,
				classes,
			});
			deliveryLogRows.push(row);
		});
		 */

		// deliveryLogRows = _.orderBy(deliveryLogRows, 'dateCreated', 'desc');
		this.setState({ deliveryLogRows, isFetchingDeliveries: false });
	};

	handleCommentPopoverOpen = (event, internalNote) => {
		this.setState({
			popoverComment: internalNote,
			commentPopoverAnchor: event.currentTarget,
		});
	};
	handleCommentPopoverClose = () => {
		this.setState({ commentPopoverAnchor: null });
	};

	render() {
		const { classes } = this.props;
		return (
			<Grid container spacing={2}>
				<Grid item md={12} xs={12}>
					{this.renderSearch()}
				</Grid>
				<Grid item md={12} xs={12}>
					{this.renderResults()}
				</Grid>

				<Popover
					id="comment-popover"
					className={classes.popover}
					classes={{ paper: classes.popOverPaper }}
					open={!!this.state.commentPopoverAnchor}
					anchorEl={this.state.commentPopoverAnchor}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					onClose={this.state.handleCommentPopoverClose}
					disableRestoreFocus
				>
					<div className={classes.commentsContainer}>
						{!!this.state.popoverComment && <div>{this.state.popoverComment}</div>}
					</div>
				</Popover>
			</Grid>
		);
	}

	renderSearch() {
		const { isExternalLogistics, users, classes } = this.props;
		const { stationFormatErrors } = this.state;

		return (
			<>
				<FMPHeadline label="Station Delivery Activity Log Search" />
				<Paper className={classes.paper}>
					<Grid container spacing={2}>
						{!isExternalLogistics && (
							<FMPUserMultiSelect {...this.setForm('forUserIds', 'Users', true)} users={users} />
						)}

						<div className={classes.divider} />
						{this.renderDateRangeOptions()}

						{this.renderSubmitButtons()}
					</Grid>
				</Paper>

				{!_.isEmpty(stationFormatErrors) && this.renderErrors(stationFormatErrors)}
			</>
		);
	}

	setDateRange = (dateRange) => {
		this.setState({ dateRange });
	};

	renderDateButton = (label, range) => {
		const { classes } = this.props;
		const { dateRange } = this.state;

		const variant = dateRange === range ? 'contained' : 'outlined';

		return (
			<Button
				className={classes.dateRange}
				variant={variant}
				color="primary"
				onClick={() => {
					this.setDateRange(range);
				}}
			>
				{label}
			</Button>
		);
	};

	renderDateRangeOptions = () => {
		const { isExternalLogistics } = this.props;
		const { dateRange } = this.state;
		let disabled = true;
		if (dateRange === 'custom') {
			disabled = false;
		}

		return (
			<>
				<Grid item md={12}>
					<FMPSectionHeader label={'Date Range'} />
				</Grid>

				<Grid item md={12} style={{ display: 'flex' }}>
					{this.renderDateButton('Today', 'today')}
					{this.renderDateButton('Last 7 days', 'last7Days')}
					{this.renderDateButton('Last 30 days', 'last30Days')}
					{!isExternalLogistics && this.renderDateButton('Custom', 'custom')}
				</Grid>

				<FMPDatePicker
					{...this.setForm('afterDate', 'Delivery Date After', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>

				<FMPDatePicker
					{...this.setForm('beforeDate', 'Delivery Date Before', true)}
					format={'MMMM Do, YYYY'}
					md={5}
					disabled={disabled}
				/>
			</>
		);
	};

	renderSubmitButtons = () => {
		const { classes } = this.props;
		const { isSearching } = this.state;

		const params = this.getApiParams();
		params.downloadCsv = true;
		const request = {
			method: 'stationDelivery.log.advancedSearch',
			params,
		};

		let host = '';
		if (isLocalhost) {
			host = 'http://localhost:3700';
		}
		const downloadUrl = `${host}/api?request=${JSON.stringify(request)}`;

		return (
			<Grid item md={12} style={{ paddingTop: 25, display: 'flex' }}>
				<Button
					className={classes.bigButton}
					variant="contained"
					color="primary"
					onClick={this.submitSearch}
					disabled={isSearching}
				>
					<Search className={classes.icon} />
					Delivery Activity Log Search
				</Button>

				<a
					href={downloadUrl}
					style={{ textDecoration: 'none', paddingRight: 5 }}
					target="_blank"
					rel="noreferrer noopener"
				>
					<Button
						className={classes.bigButton}
						variant="contained"
						color="primary"
						style={{ marginLeft: 10 }}
						disabled={isSearching}
					>
						<DownloadIcon className={classes.icon} />
						Search & Download
					</Button>
				</a>

				{isSearching && (
					<div className={classes.runningSearch}>
						<CircularProgress />
						<span style={{ paddingLeft: 5 }}>Searching...</span>
					</div>
				)}
			</Grid>
		);
	};

	renderResults() {
		const { classes } = this.props;
		const { deliveryLogRows } = this.state;

		if (_.isUndefined(deliveryLogRows)) {
			return (
				<Paper className={classes.paper} style={{ marginTop: 20 }}>
					<div className={classes.resultsHere}>Results here</div>
				</Paper>
			);
		}

		const deliveryInvoiceColumns = [
			{
				sortId: 'dateCreated',
				displayId: 'dateCreatedFormatted',
				label: 'Date',
			},
			{
				sortId: 'forUserDisplay',
				displayId: 'forUserDisplay',
				label: 'By User',
			},
			{
				sortId: 'stationDeliveryLogId',
				displayId: 'entry',
				label: 'By User',
				style: { width: '50%' },
				// }, {
				//	sortId: 'type',
				//	displayId : 'typeAndProduct',
				//	labels : ['Type', 'Product'],
			},
			{
				sortId: 'stationDeliveryId',
				displayId: 'deliveryDisplay',
				label: 'Delivery Info',
				// }, {
				// 	sortId: 'totalDeliveryAmount',
				//	displayId: 'deliveryVolumes',
				// 	label: 'Scheduled Volumes',
			},
			{
				sortId: 'internalNote',
				displayId: 'commentDisplay',
				label: 'Internal Note',
			},
		];

		return (
			<Paper className={classes.paper} style={{ marginTop: 20 }}>
				{_.isEmpty(deliveryLogRows) && (
					<div className={classes.resultsHere}>No results were returned</div>
				)}

				{!_.isEmpty(deliveryLogRows) && (
					<>
						<EnhancedTable
							isDense={true}
							columns={deliveryInvoiceColumns}
							rows={deliveryLogRows}
							defaultOrder={'desc'}
							defaultOrderBy={'dateCreated'}
						/>
					</>
				)}
			</Paper>
		);
	}

	formatStationDeliveryLog = (p) => {
		const {
			stationDeliveryLog,
			stationDeliveryLookup,
			stationLookup,
			// terminalLookup,
			//supplierLookup,
			carrierLookup,
			userLookup,
			classes,
		} = p;

		const errors = [];

		const {
			stationDeliveryLogId,
			stationDeliveryId,
			entry,
			forUserId,
			dateCreated,
		} = stationDeliveryLog;

		const stationDelivery = stationDeliveryLookup[stationDeliveryId];
		if (!stationDelivery) {
			errors.push(`Missing stationDeliveryId:${stationDeliveryId}`);
			return;
		}

		const {
			primaryProductType,
			primaryStationId,
			primaryDeliveryAmount,
			carrierId,
			deliveryWindowStartDateTime,
			isCancelled,
			internalNote,
		} = stationDelivery;

		//- Format the delivery — one line per stop
		const legs = getDeliveryLegs(stationDelivery);
		const stations = [];
		const primaryStation = stationLookup[primaryStationId] || { number: '?', name: 'Missing' };
		let totalDeliveryAmount = primaryDeliveryAmount;
		let primaryStationDisplay = `${primaryStation.number} - ${primaryStation.name}`;
		if (legs.length > 1) {
			primaryStationDisplay += ` (${primaryDeliveryAmount})`;
		}
		stations.push(primaryStationDisplay);

		legs
			.filter((leg) => leg.legNumber >= 2)
			.forEach((leg) => {
				const station = stationLookup[leg.stationId] || {
					number: '?',
					name: 'Missing',
				};
				stations.push(`${station.number} - ${station.name} (${leg.deliveryAmount})`);
				totalDeliveryAmount += leg.deliveryAmount || 0;
			});

		const dateDisplay = moment(deliveryWindowStartDateTime).format('ddd, M/D');
		const carrier = carrierLookup[carrierId] || { name: 'Missing' };
		const deliveryDisplay = (
			<Fragment>
				<div>
					<a
						href={`/logistics/stationDelivery/update/${stationDeliveryId}`}
						className={classes.linkedItem}
						target="_blank"
						rel="noreferrer noopener"
					>
						<span>Delivery #{stationDeliveryId}</span> <OpenLink className={classes.openLink} />
					</a>
				</div>
				{stations.map((st, i) => {
					return <div key={i}>{st}</div>;
				})}
				<div>{carrier.name}</div>
				{isCancelled && <div className={classes.cancelled}>CANCELLED</div>}
			</Fragment>
		);

		const deliveryDisplayForCopy = (
			<>
				{stations.map((st, i) => {
					return <div key={i}>{st}</div>;
				})}
			</>
		);

		let commentDisplay;
		if (!internalNote) {
			commentDisplay = <div>-</div>;
		} else {
			commentDisplay = (
				<div
					style={{ display: 'inline-block', color: '#2196f3' }}
					onMouseEnter={(event) => {
						this.handleCommentPopoverOpen(event, internalNote);
					}}
					onMouseLeave={this.handleCommentPopoverClose}
				>
					<NoteIcon />
				</div>
			);
		}

		const { deliveryWindowDate, deliveryWindowTime } = formatDeliveryWindow({ stationDelivery });
		const primaryProductTypeDisplay = valueToDisplay(primaryProductType);
		const row = {
			key: stationDeliveryLogId,
			deliveryType: 'Station',
			deliveryId: stationDeliveryId,
			type: 'stationDelivery',
			typeAndProduct: (
				<div>
					<div>Station Delivery</div>
					<div>{primaryProductTypeDisplay}</div>
				</div>
			),
			carrierDisplay: carrier.name,
			deliveryWindowDate,
			deliveryWindowTime,
			deliveryDateSort: deliveryWindowStartDateTime,
			deliveryDateDisplay: dateDisplay,
			deliveryDisplayForCopy,
			productType: primaryProductType,
			primaryProductType,
			deliveryDisplay,
			totalDeliveryAmount,
			isCancelled,
			commentDisplay,
			entry,
			dateCreated,
			dateCreatedFormatted: moment(dateCreated).format('M/D/YY h:mm a'),
		};

		const forUser = userLookup[forUserId];
		if (forUser) {
			row.forUserDisplay = `${forUser.firstName} ${forUser.lastName}`;
		} else {
			row.forUserDisplay = 'n/a';
		}

		const {
			firstTerminalProductType,
			firstTerminalFuelToPickupTotal,
			secondTerminalProductType,
			secondTerminalFuelToPickupTotal,
		} = stationDelivery;

		const deliveryVolumes = [
			{
				productType: firstTerminalProductType,
				total: firstTerminalFuelToPickupTotal,
			},
		];

		if (secondTerminalProductType && secondTerminalFuelToPickupTotal) {
			deliveryVolumes.push({
				productType: secondTerminalProductType,
				total: secondTerminalFuelToPickupTotal,
			});
		}

		const deliveryVolumesByProduct = {};
		row.deliveryVolumes = _.sortBy(deliveryVolumes, 'productType').map((deliveryVolume) => {
			const { productType, total } = deliveryVolume;
			deliveryVolumesByProduct[productType] = total;
			return (
				<div key={productType}>
					<span>{valueToDisplay(productType)} :</span>
					<span>{total}</span>
				</div>
			);
		});
		return row;
	};
}

function formatDeliveryWindow({ stationDelivery, bulkDelivery }) {
	if (bulkDelivery) {
		const { deliveryDate } = bulkDelivery;
		return {
			deliveryWindowDate: `${moment(deliveryDate).format('M/D/YY')}`,
			deliveryWindowTime: `All Day`,
		};
	}

	const { deliveryWindowStartDateTime, deliveryWindowEndDateTime, allDayWindow } = stationDelivery;
	const start = moment(deliveryWindowStartDateTime);
	const end = moment(deliveryWindowEndDateTime);

	if (allDayWindow) {
		return {
			deliveryWindowDate: `${start.format('M/D/YY')}`,
			deliveryWindowTime: 'All Day',
		};
	} else if (start.date() === end.date()) {
		const firstTime = start.minute() === 0 ? start.format('h') : start.format('h:mm');

		const secondTime = end.minute() === 0 ? end.format('h') : end.format('h:mm');

		let time;
		const sampm = start.format('a');
		const eampm = end.format('a');

		if (sampm === eampm) {
			time = `(${firstTime} - ${secondTime} ${sampm})`;
		} else {
			time = `(${firstTime} ${sampm} - ${secondTime} ${eampm})`;
		}

		return {
			deliveryWindowDate: `${start.format('M/D/YY')}`,
			deliveryWindowTime: time,
		};
	} else {
		return {
			deliveryWindowDate: `${start.format('M/D/YY')} - ${end.format('M/D/YY')}`,
			deliveryWindowTime: `${start.format('h:mm a')} - ${end.format('h:mm a')}`,
		};
	}
}

DeliveryActivityLogSearch.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func.isRequired,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,

	users: PropTypes.array,
	searchUsers: PropTypes.func.isRequired,

	accessToken: PropTypes.string,

	stationMap: PropTypes.object,
	carrierMap: PropTypes.object,
	invoiceDocumentMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,
	terminalMap: PropTypes.object,
	supplierMap: PropTypes.object,
	bulkCustomerMap: PropTypes.object,
	bulkDeliveryMap: PropTypes.object,
	resourceMap: PropTypes.object,

	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), UsersContainer, AuthUserContainer])(
	DeliveryActivityLogSearch
);
